import {
  CartesianGrid,
  Label,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
} from "recharts";

const ChartLine = (props) => {
  const showLegend =
    props.legends && props.legends.length === props.dataKeyY.length;

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={props.data}
        margin={{
          top: 20,
          right: 30,
          left: -10,
          bottom: 5,
        }}
      >
        <CartesianGrid
          strokeDasharray="3 3"
          stroke={props.axisStroke || "#536162"}
        />
        <XAxis
          type={props.type}
          dataKey={props.dataKeyX || "_id"}
          domain={props.xdomain || ["min", "max"]}
          stroke={props.axisStroke || "#536162"}
          ticks={props.xticks || undefined}
        >
          {props.xAxisLabel && (
            <Label
              value={props.xAxisLabel}
              offset={-3}
              position="insideBottom"
            />
          )}
        </XAxis>
        <YAxis
          label={{
            value: props.yAxisLabel,
            angle: -90,
            position: "insideLeft",
            offset: 15,
          }}
          domain={props.ydomain || undefined}
          stroke={props.axisStroke || "#536162"}
          ticks={props.yticks || undefined}
        />
        {showLegend && <Legend verticalAlign="top" height={36} />}
        <Tooltip />
        {props.dataKeyY.map((keyY, idx) => {
          const name = showLegend ? props.legends[idx] : "";
          return (
            <Line
              name={name}
              key={"datakey" + keyY}
              type="monotone"
              dataKey={keyY}
              stroke={props.stroke[idx] || "#82ca9d"}
              strokeWidth={2}
              dot={props.dot ? props.dot : false}
              isAnimationActive={false}
              connectNulls={props.connectNulls ? props.connectNulls : false}
            />
          );
        })}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ChartLine;
